module.exports = __webpack_public_path__ + "media/a4.0e3a769e.wav";